// Importing required styles, images, MUI components, and libraries
import "./helperdata.css";
import language from "../assest/image/Language.png";
import account from "../assest/image/account.png";
import Lists from "../assest/image/Lists.png";
import output from "../assest/image/output.png";
import subject from "../assest/image/subject.png";
import {
    Box,
    Button,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Typography,
    FormControl,
    Select,
    MenuItem,
    Switch,
    Input,
    InputAdornment,
    Modal,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import Cookies from "js-cookie";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import { fetchAllConversationSearchAPI } from "../redux/action/UserAction";
import {
    dateLabelReduc,
    resetFilterReduc,
    searchStringValueReduc,
    userSelector,
} from "../redux/slices/userSlice";
import { useSelector } from "react-redux";
import Chats from "../pages/user/chats";

// Utility to return current date/time in a formatted string
export function getFormattedDate() {
    const date = new Date();
    const monthNames = [/* ... */];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month} ${day} ${hours}:${minutes} ${ampm}`;
}

// Returns corresponding icon image based on provided key
export const iconfun = (iconName) => {
    const iconMap = { /* ... */ };
    return iconMap[iconName];
};

// Formats ISO datetime string into readable format using moment.js
export function formatDateTime(dateString) {
    return moment(dateString).format("MM/DD/YYYY");
}

// Custom loader component shown while submitting
export function CircularIndeterminate() {
    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <span>Submitting Query </span>
            <span class="dot-one"> .</span>
            <span class="dot-two"> .</span>
            <span class="dot-three"> .</span>
        </Box>
    );
}

// Format response string with markdown-style bold (**) or heading (##)
export const formatResponseText = (text) => {
    if (!text) return "";
    return text
        .replace(/\*\*(.*?)\*\*/g, (match, p1) => `<b>${p1}</b>`)
        .replace(/(##+)\s*(.*?)(\n|$)/g, (match, p1, p2) => `<b>${p2}</b>\n`);
};

// Styled MUI iOS-style toggle switch component


// const IOSSwitch = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   /* custom styling for the switch */
// }));

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
    width: 40,
    height: 20,
    padding: 0,
    display: "flex",
    "& .MuiSwitch-switchBase": {
        padding: 1,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(18px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: "#8259E4", // Purple
                opacity: 1,
                border: 0,
            },
        },
    },
    "& .MuiSwitch-thumb": {
        boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
        width: 18,
        height: 18,
        borderRadius: 11,
        transition: "0.3s",
    },
    "& .MuiSwitch-track": {
        borderRadius: 24 / 2,
        backgroundColor: "#1A2352", // Navy when unchecked
        opacity: 1,
        transition: "0.5s",
    },
}));


// Switch control to toggle between "My Queries" and "Shared Queries"
// export default function CustomizedSwitches({ isChecked, setIsChecked }) {
//   const handleChange = (event) => {
//     setIsChecked(event.target.checked);
//   };

//   return (
//     <div style={{ display: "flex", gap: "10px" }}>
//       <p className={`${!isChecked ? "border" : ""}`}>My Queries</p>
//       <IOSSwitch sx={{ m: 1 }} checked={isChecked} onChange={handleChange} />
//       <p className={`${isChecked ? "border1" : ""}`}>Shared Queries</p>
//     </div>
//   );
// }

export default function CustomizedSwitches({ isChecked, setIsChecked }) {
    const handleChange = (event) => {
        setIsChecked(event.target.checked);
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <p
                style={{
                    fontWeight: 500,
                    color: !isChecked ? "#1A2352" : "#999",
                    borderBottom: !isChecked ? "2px solid #1A2352" : "none",
                    paddingBottom: "2px",
                }}
            >
                My Queries
            </p>
            <IOSSwitch sx={{ m: 1 }} checked={isChecked} onChange={handleChange} />
            <p
                style={{
                    fontWeight: 500,
                    color: isChecked ? "#8259E4" : "#999",
                    borderBottom: isChecked ? "2px solid #8259E4" : "none",
                    paddingBottom: "2px",
                }}
            >
                Shared Queries
            </p>
        </div>
    );
}

// Button component for initiating a new query
export const ChatButton = ({ navigate }) => {
    return (
        <Button
            variant="contained"
            sx={{ marginRight: "10px", backgroundColor: "#1C1C1C", color: "fff", borderRadius: "12px" }}
            onClick={() => navigate("/chats")}
        >
            {/* <AddIcon sx={{ marginRight: "5px" }} /> */}
            Collaboration
        </Button>
    );
}
export const NewQueryBtn = ({ navigate }) => {
    return (
        <Button
            variant="contained"
            sx={{ backgroundColor: "#1C1C1C", color: "fff", borderRadius: "12px" }}
            onClick={() => navigate("/newquery")}
        >
            <AddIcon sx={{ marginRight: "5px" }} />
            New Query
        </Button>
    );
};

// Store user session in cookies; supports multiple user switching
export function storeUserSession(username, token, email) {
    let accounts = Cookies.get("userAccounts");
    accounts = accounts ? JSON.parse(accounts) : [];
    if (!Array.isArray(accounts)) accounts = [];

    const existingIndex = accounts?.findIndex(
        (acc) => acc?.username === username
    );

    if (existingIndex !== -1) {
        accounts[existingIndex].token = token;
    } else {
        accounts.push({ username, token, email });
    }

    Cookies.set("userAccounts", JSON.stringify(accounts), { expires: 370 });
    Cookies.set("currentUser", username, { expires: 370 });
}

// Search bar input component with clear and search icon
export const SearchInput = ({ searchText, dispatch }) => {
    return (
        <div className="search-input-container">
            <Input
                placeholder="Search"
                onChange={(e) =>
                    dispatch(searchStringValueReduc({ data: e.target.value }))
                }
                sx={{
                    padding: "2 !important",
                    top: "0 !important",
                    bottom: "0!important",
                }}
                value={searchText}
                className="search-input"
                disableUnderline
                endAdornment={
                    <InputAdornment position="start">
                        {searchText?.length > 0 ? (
                            <ClearIcon
                                onClick={() => dispatch(searchStringValueReduc({ data: "" }))}
                                style={{ cursor: "pointer" }}
                            />
                        ) : (
                            <SearchIcon className="search-icon" />
                        )}
                    </InputAdornment>
                }
            />
        </div>
    );
};



// Select dropdown to filter data based on date range
export function BasicSelect({
    labelText,
    labelIcon,
    options,
    isDisabled,
    setDateRange,
    datarange,
    dispatch,
    groupId,
    selectedDateLabel,
    setSelectedDateLabel,
    searchVal,
}) {
    const userType = sessionStorage.getItem("userType");
    const { clearFilter } = useSelector(userSelector);

    const getDateRangeFromLabel = (label) => {
        const today = new Date();
        let startDate = new Date(today);
        let endDate = new Date(today);

        switch (label) {
            case "Yesterday":
                startDate.setDate(today.getDate() - 1);
                endDate.setDate(today.getDate() - 1);
                break;
            case "Past Week":
                startDate.setDate(today.getDate() - 7);
                break;
            case "Past Month":
                startDate.setMonth(today.getMonth() - 1);
                break;
            default:
                return { startDate: "", endDate: "" };
        }

        return {
            startDate: startDate.toISOString().split("T")[0],
            endDate: endDate.toISOString().split("T")[0],
        };
    };

    const handleChange = (event) => {
        const selectedLabel = event.target.value;
        if (selectedLabel === "") {
            setSelectedDateLabel("");
            dispatch(setDateRange({ startDate: "", endDate: "" }));
        } else {
            const range = getDateRangeFromLabel(selectedLabel);
            dispatch(dateLabelReduc({ data: selectedLabel }));
            dispatch(setDateRange(range));

            if (userType === "user") {
                dispatch(
                    fetchAllConversationSearchAPI(
                        null,
                        searchVal,
                        range.startDate,
                        range.endDate,
                        false,
                        groupId,
                        null
                    )
                );
                dispatch(resetFilterReduc({ data: !clearFilter }));
            }
        }
    };

    return (
        <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth>
                <Select
                    value={selectedDateLabel}
                    disabled={isDisabled}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                        color: "gray",
                        // width: "16rem !important",
                        borderRadius: "10px !important",
                        fontSize: "1rem ",
                        height: "40px ",
                        padding: "12px ",
                    }}
                    renderValue={(selected) => {
                        if (!selected) {
                            return (
                                <Box display="flex" alignItems="center" sx={{ color: "gray" }}>
                                    {labelIcon}
                                    <em>{labelText}</em>
                                </Box>
                            );
                        }
                        return (
                            <Box display="flex" alignItems="center">
                                {labelIcon}
                                {selected}
                            </Box>
                        );
                    }}
                >
                    <MenuItem disabled value="">
                        <em>{labelText}</em>
                    </MenuItem>
                    {options?.map((e) => (
                        <MenuItem key={e?.optionValue} value={e?.optionValue}>
                            {e?.optionLabel}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

// Multi-select dropdown component with checkbox
export function BasicMultiSelect({
    labelText,
    labelIcon,
    options,
    isDisabled,
    values,
    handleChange,
}) {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 100,
            },
        },
    };

    return (
        <div>
            <FormControl>
                <Select
                    multiple
                    value={values}
                    onChange={handleChange}
                    disabled={isDisabled}
                    displayEmpty
                    sx={{
                        color: "gray",
                        width: "13rem !important",
                        borderRadius: "10px !important",
                        fontSize: "1rem ",
                        height: "40px ",
                        padding: "12px ",
                    }}
                    input={<OutlinedInput />}
                    renderValue={(selected) => {
                        if (selected?.length === 0) {
                            return (
                                <Box display="flex" alignItems="center" sx={{ color: "gray" }}>
                                    {labelIcon}
                                    <em>{labelText}</em>
                                </Box>
                            );
                        }
                        return (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    overflow: "hidden",
                                }}
                            >
                                {labelIcon}
                                {selected
                                    ?.map(
                                        (value) =>
                                            options?.find((option) => option?.optionValue === value)
                                                ?.optionLabel
                                    )
                                    .join(", ")}
                            </Box>
                        );
                    }}
                    MenuProps={MenuProps}
                >
                    {options?.map((item) => (
                        <MenuItem key={item?.optionValue} value={item?.optionValue}>
                            <Checkbox checked={values?.includes(item?.optionValue)} />
                            <ListItemText primary={item?.optionLabel} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

// Custom hook for debouncing any fast-changing value (like search input)
export function useDebounce(value, delay = 500) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
}

// Prevents user from navigating backward using browser's back button
// export const usePreventBackNavigation = () => {
//   useEffect(() => {
//     const handlePopState = () => {
//       window.history.pushState(null, "", window.location.href);
//     };
//     window.history.pushState(null, "", window.location.href);
//     window.addEventListener("popstate", handlePopState);

//     return () => {
//       window.removeEventListener("popstate", handlePopState);
//     };
//   }, []);
// };
